export enum EBORDERS {
  HAVAEE = 'هوایی',
  SHALAMCHE = 'شلمچه',
  KHOSRAVI = 'خسروی (استان کرمانشاه)',
  TAMARCHIN = 'تمرچین (استان آذربایجان غربی)',
  BASHMAGH = 'باشماق (استان کردستان)',
  CHAZABE = 'چذابه',
  MEHRAN = 'مهران',
}
